import { useMemo } from "react";
import { useAuth } from "../context/AuthContext";

export function useUsersApi() {
  const { apiFetch } = useAuth();

  return useMemo(
    () => ({
      getAll: () => apiFetch("/users"),

      getById: (id) => apiFetch(`/users/${id}`),

      getPerformance: (days = 30) => apiFetch(`/users/performance?days=${days}`),

      create: (userData) =>
        apiFetch("/users", {
          method: "POST",
          body: userData,
        }),

      update: (id, userData) =>
        apiFetch(`/users/${id}`, {
          method: "PUT",
          body: userData,
        }),

      remove: (id) =>
        apiFetch(`/users/${id}`, {
          method: "DELETE",
        }),

      setLeader: (id, value) =>
        apiFetch(`/users/${id}/leader`, {
          method: "PATCH",
          body: JSON.stringify({ leadUser: value }),
        }),

      saveOrder: (payload) =>
        apiFetch(`/users/order`, {
          method: "PATCH",
          body: JSON.stringify({ payload }),
        }),
    }),
    [apiFetch],
  );
}
